// @flow
import React, { Component } from 'react'
import { Buttons, FormControls } from '@lanetix/unum'
import axios from 'axios'
import { withRouter } from 'client/apps/login/with-router.js'
import owasp from 'owasp-password-strength-test'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { PasswordStrengthTooltip } from './password-strength-tooltip'
import routerFunction from 'client/route.js'

const { Text } = FormControls
const INTERVAL = 50 // 50ms

owasp.config({
  allowPassphrases: false,
  maxLength: 128,
  minLength: 8,
  minPhraseLength: 20,
  minOptionalTestsToPass: 3
})

type OnInputEventType = {
  target: {
    value: string
  }
}

const defaultPasswordStrength = {
  errors: [],
  failedTests: [],
  strong: false
}
// $FlowFixMe 
export class ChangePasswordForm extends Component {
  props: {
    params: {
      resetToken: string
    },
    router: Object
  }

  // state: {
  //   password: string,
  //   confirmPassword: string
  // }

  state: any = {
    password: '',
    passwordStrength: defaultPasswordStrength,
    confirmPassword: ''
  }
  // $FlowFixMe 
  onSubmit: ((event: any) => Promise<void>) = async (event: SyntheticEvent) => {
    event.preventDefault()
    const { params: { resetToken } } = this.props
    const router = routerFunction()
    const { password, confirmPassword } = this.state
    if (password === confirmPassword) {
      try {
        await axios.post('/api/v1/forgot-password/reset', { password, resetToken })
        router.navigate('/forgot-password/reset/success')
      } catch (e) {
        router.navigate('/forgot-password/reset/error')
      }
    }
  }

  onInput: ((key: string, OnInputEventType) => void) = (key: string, { target: { value } }: OnInputEventType) => {
    if (key !== 'password') {
      this.setState({ [key]: value })
    } else {
      const passwordStrength = value.length
        ? owasp.test(value)
        : defaultPasswordStrength

      this.setState(// $FlowFixMe
        { password: value, passwordStrength }
      )
    }
  }

  renderPassword: ((showValidationMessage: boolean) => any) = (showValidationMessage: boolean) =>
    <Text
      className='password-input'
      data-tooltip-content
      data-tooltip-id='password-strength'
      data-tooltip-variant='light'
      validationMessage={showValidationMessage
        ? 'unmet requirements'
        : undefined}
      onInput={this.onInput.bind(this, 'password')}
      placeholder='new password'
      type='password'
    />

  renderTooltip: ((errors: Array<number>, empty: boolean, strong: boolean) => any) = (errors: Array<number>, empty: boolean, strong: boolean) =>
    <ReactTooltip
      className='pw-reset-password__tooltip'
      openOnClick
      float={false}
      render={() => {
        return (
          <PasswordStrengthTooltip
            errors={errors}
            empty={empty}
            strong={strong}
          />
        )
      }}
      id='password-strength'
      place='right'
    />

  renderSubmitButton: ((disabled: boolean) => any) = (disabled: boolean) =>
    <Buttons.PillButton
      className='pw-reset-password__button'
      disabled={disabled}
      type='submit'
      success
      block
    >
      Submit
    </Buttons.PillButton>

  render (): any {
    const { password, passwordStrength, confirmPassword } = this.state
    const { failedTests: errors, strong } = passwordStrength
    const passwordInvalid = password.length > 0 && !strong
    const passwordsDontMatch = password.length > 0 &&
      confirmPassword.length > 0 &&
      password !== confirmPassword
    const disableSubmitButton = passwordInvalid ||
      password.length === 0 ||
      confirmPassword.length === 0 ||
      passwordsDontMatch

    return (
      <form className='pw-reset-password__form' onSubmit={this.onSubmit}>
        <div className='validation-warning'>
          <h4>{(passwordsDontMatch)
            ? <span>Both fields must match.</span>
            : null}
          </h4>
        </div>
        {this.renderPassword(passwordInvalid)}
        {this.renderTooltip(errors, password.length === 0, strong)}
        <Text
          className='confirm-password-input'
          placeholder='confirm new password'
          type='password'
          onInput={this.onInput.bind(this, 'confirmPassword')}
        />
        {this.renderSubmitButton(disableSubmitButton)}
      </form>
    )
  }
}

export default (withRouter(ChangePasswordForm): any)
